
// import React from "react";

// export default function Pagination({ currentPage, pagesCount, onPageChange,inThisPage }) {
//   if (pagesCount <= 1) return null; // اگر فقط یک صفحه باشد، نمایش داده نمی‌شود

//   const pages = Array.from({ length: pagesCount }, (_, i) => i + 1);

//   // فقط صفحاتی که باید نمایش داده شوند را فیلتر می‌کنیم
//   const visiblePages = pages.filter(
//     (page) =>
//       page === 1 ||
//       page === pagesCount ||
//       (page >= currentPage - 1 && page <= currentPage + 1)
//   );

//   return (
//     <div className="pagination">
//       {/* دکمه قبلی */}
//       <button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 1}
//         className="pagination-btn prev"
//       >
//         قبلی
//       </button>


//       {/* دکمه‌های صفحه با ... */}
//       {visiblePages.map((page, idx, arr) => {
//         const prev = arr[idx - 1];
//         const hasGap = prev && page - prev > 1;

//         return (
//           <React.Fragment key={page}>
//             {hasGap && <span className="dots">...</span>}
//             <button
//               onClick={() => onPageChange(page)}
//               className={`pagination-btn ${currentPage === page ? "active" : ""}`}
//             >
//               {page}
//             </button>

   
//           </React.Fragment>
//         );
//       })}

//       {/* دکمه بعدی */}
//       <button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === pagesCount}
//         className="pagination-btn next"
//       >
//         بعدی
//       </button>

//                <select className="order-count-select" value="placeholder">
//   <option value="placeholder" disabled>
//     تعداد: {inThisPage}
//   </option>
// </select>
//     </div>

    
//   );
// }


import React from "react";

export default function Pagination({ currentPage, pagesCount, onPageChange, inThisPage }) {
  if (pagesCount <= 1) return null;

  return (
    <div className="pagination">
      {/* دکمه قبلی */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-btn prev"
      >
        قبلی
      </button>

      {/* اولین صفحه - اگر با صفحه فعلی یکی نباشد */}
      {currentPage > 1 && (
        <button
          onClick={() => onPageChange(1)}
          className="pagination-btn"
        >
          1
        </button>
      )}

      {/* سه نقطه اول - اگر فاصله بین صفحه اول و صفحه قبلی وجود داشته باشد */}
      {currentPage > 3 && (
        <span className="dots">...</span>
      )}

      {/* صفحه قبلی - اگر بین صفحه اول و صفحه فعلی باشد */}
      {currentPage > 2 && (
        <button
          onClick={() => onPageChange(currentPage - 1)}
          className="pagination-btn"
        >
          {currentPage - 1}
        </button>
      )}

      {/* صفحه فعلی */}
      <button
        onClick={() => onPageChange(currentPage)}
        className="pagination-btn active"
      >
        {currentPage}
      </button>

      {/* صفحه بعدی - اگر آخرین صفحه نباشد */}
      {currentPage < pagesCount && (
        <button
          onClick={() => onPageChange(currentPage + 1)}
          className="pagination-btn"
        >
          {currentPage + 1}
        </button>
      )}

      {/* سه نقطه دوم - اگر فاصله بین صفحه بعدی و آخرین صفحه وجود داشته باشد */}
      {currentPage + 1 < pagesCount - 1 && (
        <span className="dots">...</span>
      )}

      {/* آخرین صفحه - اگر با صفحه فعلی یکی نباشد */}
      {currentPage < pagesCount && (
        <button
          onClick={() => onPageChange(pagesCount)}
          className="pagination-btn"
        >
          {pagesCount}
        </button>
      )}

      {/* دکمه بعدی */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === pagesCount}
        className="pagination-btn next"
      >
        بعدی
      </button>

      {/* نمایش تعداد آیتم‌ها */}
      <div className="items-count">
        تعداد: {inThisPage}
      </div>
    </div>
  );
}